import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwExpressionService, DwFormContextMode, DwMdFormContextInfo, DwMetaDataFormApi, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } from '@devwareapps/devware-cap';
import { debounceTime } from 'rxjs/operators';
import { AppMetaDataLookups } from '../../../../meta-data/app-meta-data.service';
import { TimerEntity, TimersMetaDataItemNames, TimerStatusAllItems } from '../../meta-data/timers-meta-data.service';
import { TimerUtilService } from '../../services/timer-util.service';


@DwComponent({
  name: 'Timer UI Util',
  key: 'timerUiUtil',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: TimersMetaDataItemNames.Timer,
})
@Component({
  selector: 'app-timer-ui-util',
  template: `
  `
})
export class TimerUiUtilComponent extends DwSectionBaseComponent {
  timerMinutesFC: FormControl;
  dueDateTimeFC: FormControl;
  lastTimerValue: any;
  lastJobId: any;
  formApi: DwMetaDataFormApi;
  jobSiteFC: FormControl;
  lastStatusId: number;
  startDateTimeFC: FormControl;


  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwFormStateService: DwMetaDataFormStateService,
    private timerUtilService: TimerUtilService

  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

    this.formApi = this.dwFormStateService.state.formApi;
  }
  ngOnInit(): void {

  }

  setupComponentComplete() {
    // Updates the due date time when the Timer Minutes value is updated
    this.timerMinutesFC = this.getOrCreateFormControl("TimerMinutes");
    this.dueDateTimeFC = this.getOrCreateFormControl("DueDateTime");
    this.startDateTimeFC = this.getOrCreateFormControl("StartDateTime");
    this.jobSiteFC = this.getOrCreateFormControl("Ethos_JobSiteId");

    this.runAfterFormDataLoaded(() => {
      this.setupSubscriptions();
    });
  }

  private setupSubscriptions() {
    this.lastTimerValue = this.timerMinutesFC.value;

    // Initialize form by runnig this once
    const timerEntity = this.formApi.getFormData<TimerEntity>();

    // this.handleUpdate(timerEntity);

    this.subscriptions.push(
      this.formApi.getFormDataChanges<TimerEntity>(400)
        .subscribe(timerEntity => {
          this.handleUpdate(timerEntity);
        }));
  }

  handleUpdate(timerEntity: TimerEntity) {
    // Update the Due Date
    this.updateDueDate(timerEntity);

    this.updateStartDate(timerEntity);

    this.setFirstJobSite(timerEntity);
  }


  setFirstJobSite(timerEntity: TimerEntity) {
    if (!timerEntity?.Ethos_JobId) {
      if (timerEntity?.Ethos_JobSiteId) {
        this.jobSiteFC.setValue(null);
        this.lastJobId = null;
      }

      return;
    }

    if (this.lastJobId == timerEntity.Ethos_JobId) {
      return;
    }

    this.lastJobId = timerEntity.Ethos_JobId;

    this.subscriptions.push(
      // This is cache
      this.dwMetaDataService.getLookup(AppMetaDataLookups.JobSiteSiteInfo, [{ ParamName: 'JobId', ParamValue: timerEntity.Ethos_JobId.toString() }])
        .subscribe(lookupItems => {
          if (lookupItems.length == 0) {
            return;
          }
          if (timerEntity.Ethos_JobSiteId) {
            const existingLookup = lookupItems.find(li => li.Id == timerEntity.Ethos_JobSiteId.toString());

            if (existingLookup) {
              return;
            }
          }

          const newJobSite = lookupItems[0].Id;

          this.jobSiteFC.setValue(newJobSite);
        }));

  }

  updateDueDate(timerEntity: TimerEntity) {
    if (!timerEntity?.TimerMinutes) {
      return;
    }

    const timerMinutes = timerEntity.TimerMinutes;

    if (timerMinutes == this.lastTimerValue && timerEntity.DueDateTime) {
      return;
    }

    this.lastTimerValue = timerMinutes;

    const newDueDate = this.timerUtilService.addDateTimeOffset(timerMinutes);

    this.dueDateTimeFC.setValue(newDueDate);
  }


  updateStartDate(timerEntity: TimerEntity) {
    if (!timerEntity?.TimerStatusId || this.lastStatusId == timerEntity.TimerStatusId) {
      return;
    }


    if (!this.lastStatusId && timerEntity?.TimerId) {
      this.lastStatusId = timerEntity.TimerStatusId; 
      
      return;
    }


    this.lastStatusId = timerEntity.TimerStatusId;

    if (timerEntity.TimerStatusId == TimerStatusAllItems.Active) {
      const newStartDate = this.timerUtilService.addDateTimeOffset(0);

      this.startDateTimeFC.setValue(newStartDate);
    }
  }


}
